<template>
  <div class="content-box flex column gap-20 flex-1">
    <div
      class="section-box outline"
      style="flex: 1; display: flex; flex-direction: column"
    >
      <div class="flex column gap-20">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Danh sách khách</span>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="flex-1">
        <GridVx
          ref="customerGrid"
          :columns="customerCols"
          :auto-select-first-row="false"
          :auto-size-cell="false"
          :get-row-style="getRowStyle"
          :is-row-selectable="isRowSelectable"
          dom-layout="scroll"
          :rows="customerRows"
          class="agGrid"
          @selectionChanged="rowClicked"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getRoomTransactionBooking } from '@/api/cashier_service/postTransaction'
export default {
  data() {
    return {
      isRowSelectable: node => !node.data.isFullWidthRow,
      defaultParams: {
        arrive_from: null,
        arrive_to: null,
        check_out_today: null,
        checked_out: null,
        company_info: null,
        customer_info: null,
        depart_from: null,
        depart_to: null,
        in_house: true,
        reserved: null,
        surplus: null
      },
      searchParams: {},
      customerCols: [
        {
          headerName: this.$t('grid.column.subBookingCode'),
          field: 'sub_booking_code',
          tooltipField: 'sub_booking_code',
          width: 120
        },
        // {
        //   headerName: this.$t('grid.column.confirm'),
        //   field: 'confirm_code',
        //   tooltipField: 'confirm_code',
        //   width: 120
        // },
        {
          headerName: this.$t('grid.column.customerInfo'),
          field: 'full_name',
          tooltipField: 'full_name',
          flex: 1,
          minWidth: 200
        },
        {
          headerName: this.$t('grid.column.roomNum'),
          field: 'room_num',
          tooltipField: 'room_num',
          width: 120
        },
        {
          headerName: this.$t('grid.column.agentName'),
          field: 'agent_name',
          tooltipField: 'agent_name',
          width: 500
        }
        // {
        //   headerName: this.$t('grid.column.balance'),
        //   field: 'surplus',
        //   valueGetter: param => {
        //     return this.$displayCurrency(param.data.surplus)
        //   },
        //   tooltipValueGetter: param => {
        //     return this.$displayCurrency(param.data.surplus)
        //   },
        //   width: 120
        // },
        // {
        //   headerName: this.$t('grid.column.comeDate'),
        //   field: 'arrive',
        //   valueGetter: param => {
        //     return this.$displayDate(param?.data?.arrive) || null
        //   },
        //   width: 120
        // },
        // {
        //   headerName: this.$t('grid.column.departDate'),
        //   field: 'depart',
        //   valueGetter: param => {
        //     return this.$displayDate(param?.data?.depart) || null
        //   },
        //   width: 120
        // }
      ],
      customerRows: []
    }
  },
  computed: {
    bookingInfo() {
      return this.$store.getters['cashier']
    },
    // call api attach data when this variable change
    changePostTransactionListIndex() {
      return this.$store.getters['postTransactionCustomerListIndex']
    }
  },
  watch: {
    changePostTransactionListIndex() {
      this.attachData(this.searchParams)
    }
  },
  mounted() {},
  methods: {
    getRowStyle(params) {
      if (params.data.group_master) {
        console.debug('params', params)
        return { 'background-color': '#fff9c4' }
      }
      return null
    },
    async attachData(params = this.defaultParams) {
      Object.assign(this.searchParams, params)
      const data = await getRoomTransactionBooking(params)
      this.customerRows = data.data.map(item => {
        if (item.title) {
          return {
            ...item,
            isFullWidthRow: true,
            name: item.group_name
          }
        } else {
          return item
        }
      })
      // this.$store.dispatch('cashier/changeRowSelected', false)

      // Get url params
      this.$store.dispatch('cashier/restoreAllStates')
      const urlParams = new URLSearchParams(window.location.search)
      const bookingId = urlParams.get('booking_id')
      if (bookingId) {
        // eslint-disable-next-line eqeqeq
        const row = this.customerRows.filter(item => item.id == bookingId)
        this.onStoreClickedData(row[0])
      }
    },
    onStoreClickedData(data = []) {
      // Reset related data in store
      this.$store.dispatch('cashier/addCustomerInfo', data)
      this.$store.dispatch('cashier/addTransactions', [])
      this.$store.dispatch('cashier/addSelectedTab', {})
      // this.$store.dispatch('cashier/addAllTranPages', [])
      this.$store.dispatch('cashier/changeRowSelected', true)
      this.$store.dispatch('cashier/changeKey')
    },
    async rowClicked(data) {
      if (!data[0].id) {
        return
      } else {
        this.onStoreClickedData(data[0])
      }
    }
  }
}
</script>
